"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

// Next renders this instead of the root layout when an error escapes every
// boundary (including one thrown by the root layout itself). The in-app
// ErrorBoundary can't reach that case — the tree it wraps no longer exists —
// so this is the only path by which a root-level crash reaches Sentry.
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div role="alert" className="p-4 text-sm text-red-700">
          Something went wrong. The error has been reported.
        </div>
      </body>
    </html>
  );
}
